import toast from "react-hot-toast";
import * as Sentry from "@sentry/nextjs";
import { longPolling } from "@qoohoo/common/utils/functions";
import { sanitise } from "@qoohoo/common/utils/string";
import {QOOHOO_WEBSITE_DOMAIN} from "@qoohoo/common/constants/env";
import httpf from "../utils/frontend/httpf";


function getCustomPaymentMethodsConfig (creatorId) {
  const creatorIds = [
    '3g0sf8h5', // staging
    // 'z34tcqj2', 'le5iriex' // production
  ];

  const hasCustomConfig = creatorIds.find(id => id === creatorId.toLowerCase());

  let config;

  if (hasCustomConfig) {
    config = {
      display: {
        hide: [
          {method: "emi"},
          {method: "paylater"},
          {method: "card"},
          {method: "netbanking"},
          {method: "wallet"},
        ],
      },
    };
  }

  return config;
}

export async function openPayment(data) {
  return new Promise(async (resolve, reject) => {
    try {
      const {
        orderId,
        customData,
        setIsDoingPayment,
        setIsLoading,
        setLoadingMessage,
        closeModal,
        setReadyToPay,
        creatorId
      } = data;

      const skipDescriptionForCategories = ["finance", "education", "mentorship"];
      const categoryName = customData.category || '';

      let description = (skipDescriptionForCategories.indexOf(categoryName.toLowerCase()) > -1) ? "" : customData.description;
      description = "";

      const options = {
        key: process.env.RAZORPAY_KEY_ID,
        order_id: orderId,
        name: "qoohoo",
        description: sanitise(description),
        image: `${QOOHOO_WEBSITE_DOMAIN}/assets/app-logo.svg`,
        retry: { enabled: true },
        remember_customer: true,
        theme: {
          image_frame: false,
        },
        handler: async () => {
          if (setIsDoingPayment) {
            setIsDoingPayment(false);
          }

          if (setIsLoading) {
            setIsLoading(true);
          }

          if (typeof setLoadingMessage === "function") {
            setLoadingMessage("Registering...");
          }

          try {
            await longPolling(function () {
              return httpf
                .post("/api/payment-status", { id: orderId })
                .then((res) => {
                  const isSuccess = res && res.status == 200;
                  const isOrderPaymentMarkedSuccess = isSuccess ? res.data.is_order_paid : null;

                  if (isOrderPaymentMarkedSuccess) {
                    resolve(true);

                    return true;
                  }
                })
                .catch((err) => {
                  console.log(err);
                  Sentry.captureException(err);
                })
            });
          } catch (error) {
            if (setIsLoading) {
              setIsLoading(false);
            }
            Sentry.captureException(error);
            reject("Something went wrong. Please refresh the page!");
          } finally {
            if(setIsLoading) {
              setIsLoading(false);
            }
          }
        },
        modal: {
          ondismiss: async () => {
            if (setIsDoingPayment) {
              setIsDoingPayment(false);
            }
            if (setIsLoading) {
              setIsLoading(false);
            }
            if (setReadyToPay) {
              setReadyToPay(false);
            }
            if (closeModal) {
              closeModal();
            }

            toast.error(`Payment not completed. Try again!`);
          },
        },
        readonly: {
          contact: !!customData.user_mobile,
          email: false,
        },
        prefill: {
          contact: customData.user_mobile,
          email: customData.user_email || "members@qoohoo.in", // Caution: Razorpay skips email if void@razorpay.com is present. So, success email isn't sent to customer via email
        },
      };

      if (creatorId) {
        const customPaymentMethodsConfig = getCustomPaymentMethodsConfig(creatorId);

        if(customPaymentMethodsConfig) {
          options.config = customPaymentMethodsConfig;
        }
      }

      openCheckout(options);
      // const razorpay = new window.qoohooCheckout(options); // Use this if on custom domain
    } catch (error) {
      Sentry.captureException(error);
      reject(error);
    }
  });
}

function openCheckout(options) {
  if (window.Razorpay) {
    const razorpay = new window.Razorpay(options);
    razorpay.open();
  } else if(window.qoohooCheckout) {
    window.qoohooCheckout(options);
  }
}
